import * as React from "react";
import {useEffect} from "react";
import Container from '@mui/material/Container';
import {useLocation, useNavigate} from "react-router-dom";
import api from "../../utils/api";
import axios from 'axios';
import reservationStore from "../../store/reservationStore";

// localStorage 값이 없으면 JSON.parse('') 가 예외를 던진다.
const readStoredJson = (key: string) => {
  const raw = localStorage.getItem(key);
  if (raw === null || raw === '') return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

/**
 * 예약 확정 응답 판정.
 * message 와 success 중 한쪽만 내려오는 경우가 있어 둘 다 안전하게 확인한다.
 * 기존 코드는 res.data.message.toString() 을 먼저 호출해서, message 가 없는
 * 성공 응답에서도 TypeError 가 났다(그리고 그 오류가 catch 에서 로그만 남아
 * 사용자는 빈 화면에 그대로 남았다).
 */
const isPaymentConfirmed = (data: any) =>
  String(data?.message ?? '').toLowerCase() === 'success' ||
  String(data?.success ?? '').toLowerCase() === 'true';

const SetPayValidation = (props: any) => {
  const storeData: any = reservationStore();
  const location = useLocation();
  const navigate = useNavigate();
  // 이 화면은 결제창에서 돌아온 직후 잠깐 머무는 중간 화면이다.
  // 아무것도 렌더하지 않으면 처리 중인지 멈춘 것인지 사용자가 알 수 없다.
  const [statusText, setStatusText] = React.useState('결제 결과를 확인하고 있습니다.');

  useEffect(() => {

    const locationSearch = new URLSearchParams(location.search);
    const reservationTmpId = locationSearch.get('reservationTmpId');
    const familyId = encodeURIComponent(locationSearch.get('family_id') || '');
    const impUid = locationSearch.get('imp_uid');
    const merchantUid = locationSearch.get('merchant_uid');
    const imp_success = locationSearch.get('imp_success');
    const userName = locationSearch.get('userName');
    const wishDate = locationSearch.get('wishDate');
    
    // 결제 결과 처리.
    // 어떤 경로로 실패하더라도 사용자를 이 빈 중간 화면에 남겨두지 않는다.
    // 기존 코드는 실패 시 console.log 만 하고 이동하지 않아 화면이 멈춘 것처럼 보였다.
    (async () => {
      // 포트원 결제 정상 처리
      if (imp_success === 'true') {
        try {
          // 임시 저장 상태인 예약 정보를 온전한 예약 상태로 저장
          const res = await api.post(`customer/api/v2/customers/${encodeURIComponent(localStorage.getItem("userCusID") || '')}/reservations/tmp/${reservationTmpId}/rebate/${impUid}/payments/${merchantUid}?family_id=${familyId}`, []);
          if (!isPaymentConfirmed(res.data)) {
            throw Error(String(res.data?.message ?? '예약 확정 응답을 확인할 수 없습니다.'));
          }

          alert("결제가 완료되었습니다.");
          // 예약 완료 메세지 푸쉬 알림
          /*postMessage('PushAlarm', JSON.stringify({
            title: '듀얼헬스'
            , contents: `[건강 검진] ${userName}님 ${wishDate} 일자로 예약 접수 되었습니다.`
          }));*/

          // 알림톡은 부가 기능이다. 예약은 이미 확정됐으므로 여기서 실패해도 이동을 막지 않는다.
          // 기존에는 이 호출이 실패하면 navigate 가 실행되지 않아 결제에 성공해도 화면이 멈췄다.
          try {
            await sendAT(res.data.data);
          } catch (error) {
            console.log(error);
            alert("알림톡 전송에 실패했습니다.");
          }

          navigate('/MyPage/ReservationView');
        } catch (error) {
          // 결제는 승인됐지만 예약 확정 확인에 실패한 상태다.
          // 임의로 취소 처리하지 않고, 사용자가 실제 예약 상태를 확인할 수 있는 곳으로 보낸다.
          console.log(error);
          setStatusText('예약 확정 확인에 실패했습니다.');
          alert("결제는 처리되었으나 예약 확정 확인에 실패했습니다. 예약 내역에서 상태를 확인해 주세요.");
          navigate('/MyPage/ReservationView');
        }
        return;
      }

      // 임시 저장 상태인 예약 정보 삭제
      alert("결제 중 오류가 발생하였습니다.");
      setStatusText('결제가 취소되었습니다.');
      try {
        await api.delete(`customer/api/v2/customers/${encodeURIComponent(localStorage.getItem("userCusID") || '')}/reservations/tmp/${reservationTmpId}/rebate/payments/${merchantUid}`);
      } catch (error) {
        // 임시 예약 삭제 실패는 서버에 임시 데이터가 남는 문제이지, 사용자가 붙잡혀 있을 이유는 아니다.
        console.log(error);
      }
      navigate('/reservation');
    })();

    return () => {
      storeData.setReservationInfo('groudPrice', 0);
    };
    
  }, []);
  
  const postMessage = (type: string, data: any) => {
    var win: any = window;
    win.ReactNativeWebView?.postMessage(JSON.stringify({ type, data }));
  };
  
  // 알림톡 관련 api
  const bizppurio = axios.create({
    baseURL: 'https://api.dualhealth.kr/nodes/bizppurio',
    timeout: 5000
  })

  // 알림톡 함수
  async function sendAT(paramData :any) {

    // 세 값 중 하나라도 없으면 JSON.parse('') 가 예외를 던졌다. 호출부가 catch 하도록 명시적으로 알린다.
    const companyInfo = readStoredJson("companyInfo");
    const FAM_INFOS = readStoredJson("FAM_INFO");
    const HOS_INFO = readStoredJson("HOS_INFO");
    if (companyInfo === null || FAM_INFOS === null || HOS_INFO === null) {
      throw Error('알림톡 전송에 필요한 정보가 없습니다. (companyInfo / FAM_INFO / HOS_INFO)');
    }

    const isRebateDirectly = String(companyInfo['is_rebate_directly']).toLowerCase() === 'true';
    const isB2C = String(companyInfo['type']).toLowerCase() === "b2c";
    const isB2B2C = parseInt(FAM_INFOS.supportPercent) < 0 ;
    const IS_PAYMENT = isRebateDirectly && (isB2C || isB2B2C);

    const data = {
      type: companyInfo['type'],
      company_id: companyInfo['company_id'],
      company_name: companyInfo['company_name'],
      is_rebate_directly: companyInfo['is_rebate_directly'],
      rebate_price: companyInfo['rebate_price'],
      userName: FAM_INFOS['famName'],
      phone: FAM_INFOS['phone'],
      hospital_name: HOS_INFO['name'],
      package_name: paramData.pkgName,
      firstWishDate: paramData.firstWishDate,
      price: storeData.reservationInfo && storeData.reservationInfo.groudPrice,
    }

    // 값이 비어 있을 수 있어 String() 으로 감싼다. 기존에는 undefined 에 toLowerCase 를 호출해 TypeError 가 났다.
    const companyType = String(data.type ?? '');
    const companyId = String(data.company_id ?? '');

    const info = {
      service: {
        "type": companyType.toLowerCase(),
        "target": companyId.includes("#") || companyId === "dualhealth" ? "customer" : companyId.toLowerCase(),
        "name": "건강검진"
      },
      "company": {
        "name": data.company_name,
        "isRebateDirectly": IS_PAYMENT,
        "rebatePrice": data.rebate_price
      },
      "family": {
        "name": data.userName,
        "phone": String(data.phone ?? '').replaceAll(/[^\d]/ig, "")
      },
      "reservation": {
        "hospitalName": data.hospital_name,
        "packageName": data.package_name,
        "firstWishDate": data.firstWishDate,
        "secondWishDate": '-',
        "confirmedDate": null,
        "priceToPay": data.price
      }
    }
    // 여기서 .catch(e => alert(...)) 로 삼키면 undefined 가 반환되고,
    // 바로 아래 sendMSG.data 에서 TypeError 가 났다. 실패는 호출부가 처리한다.
    const sendMSG: any = await bizppurio.post('/v1/message?msg=reservation_register', info);
    return sendMSG.data;
  }
  
  
  
  return (
    <Container sx={{ py: 6, textAlign: 'center', color: '#555' }}>
      {statusText}
    </Container>
  );
}

export default SetPayValidation;
